"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetConnectedAccountQueryToJSON = exports.GetConnectedAccountQueryFromJSONTyped = exports.GetConnectedAccountQueryFromJSON = void 0;
function GetConnectedAccountQueryFromJSON(json) {
    return GetConnectedAccountQueryFromJSONTyped(json, false);
}
exports.GetConnectedAccountQueryFromJSON = GetConnectedAccountQueryFromJSON;
function GetConnectedAccountQueryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'discordMemberId': json['discordMemberId'],
    };
}
exports.GetConnectedAccountQueryFromJSONTyped = GetConnectedAccountQueryFromJSONTyped;
function GetConnectedAccountQueryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'discordMemberId': value.discordMemberId,
    };
}
exports.GetConnectedAccountQueryToJSON = GetConnectedAccountQueryToJSON;
